import { 
  SETTLEMENTS_ERROR,
  SETTLEMENTS_SUCCESS,
  SETTLEMENTS_LOADING,
  SETTLEMENT_CREATION_SET_SPONSOR_SLUG,
  SETTLEMENT_CREATION_SET_DATE_FROM,
  SETTLEMENT_CREATION_SET_DATE_TO,
  SELECT_SETTLEMENT_FOR_DETAIL,
  SET_SETTLEMENT_DETAIL,
  CLEAN_SETTLEMENT_DETAIL,
  SETTLEMENT_CREATION_BACK_STEP,
  SETTLEMENT_CREATION_NEXT_STEP,
  SET_PENDING_AUTHORIZATIONS,
  SET_SETTLEMENT_ID,
  CLEAR_SETTLEMENT_CREATION,
  SET_CLAIMS,
  CLEAR_CLAIMS,
  SET_EXCLUDED_CLAIMS,
  CLEAR_EXCLUDED_CLAIMS,
  COMPLETE_ADD_AUTHORIZATIONS_STEP,
  SET_SETTLEMENT_CREATION_RESULT,
  RESET_SETTLEMENT_CREATION_STATE,
  SET_UPLOAD_SETTLEMENT_FILES_STATUS,
  SET_SETTLEMENT_SUMMARY,
  SETTLEMENT_CREATION_SET_COVERAGES,
  SETTLEMENT_DOCUMENTS,
  MANUAL_AUTHORIZATION_TOGGLE,
  MANUAL_AUTHORIZATION_SET_QUANTITY,
  MANUAL_AUTHORIZATION_SET_AMOUNT
}from './types';

export default {

  [SETTLEMENTS_SUCCESS]: (state, payload) => {
      state.settlements = payload.content
      state.links = payload.links
      state.page = payload.page
  },

  [SETTLEMENTS_ERROR]: (state, payload) => {
      state.errorAlert = true
      state.createSettlement.errorMessage = payload
  },

  [SETTLEMENTS_LOADING]: (state, payload) => {
      state.loadingSettlements = payload
  },

  [SETTLEMENT_CREATION_SET_SPONSOR_SLUG]: (state, payload) => {
    state.createSettlement.sponsorSlug = payload
  },

  [SETTLEMENT_CREATION_SET_DATE_FROM]: (state, payload) => {
    state.createSettlement.dates.from = payload
  },

  [SETTLEMENT_CREATION_SET_DATE_TO]: (state, payload) => {
    state.createSettlement.dates.to = payload
  },
  
  [SELECT_SETTLEMENT_FOR_DETAIL]: (state, payload) => {
    state.settlementSelected = payload
  },

  [SET_SETTLEMENT_DETAIL]: (state, payload) => {
    state.settlementDetail = payload.content
    state.links = payload.links
    state.page = payload.page
  },

  [CLEAN_SETTLEMENT_DETAIL]: (state) => {
    state.settlementDetail = []
    state.settlementSelected = {}
    state.links = {}
    state.page = {}
  },

  [SETTLEMENT_CREATION_BACK_STEP]: (state) => {
    if(state.createSettlement.actualStep > 1){
      state.createSettlement.actualStep--;
    }
  },

  [SETTLEMENT_CREATION_NEXT_STEP]: (state) => {
    state.createSettlement.actualStep++;
  },

  [SET_PENDING_AUTHORIZATIONS]: (state, payload) => {
    state.authorizations = payload.content,
    state.links = payload.links
    state.page = payload.page
  },

  [SET_SETTLEMENT_ID]: (state, payload) => {
    state.createSettlement.settlementId = payload
  },

  [CLEAR_SETTLEMENT_CREATION]: (state) => {
    state.createSettlement= {
      sponsorSelectionComplete: false,
      addAuthorizationsComplete: false,
      createSettlementResult: "",
      settlementId: {},
      sponsorSlug: {},
      dates: {
        from: "",
        to: ""
      },
      includedClaims: [],
      excludedClaims: [],
      actualStep: 1,
      errorMessage: '',
      uploadedFiles: false,
      coverages: []
    },
    state.settlementSelected = {},
    state.settlementSummary = {},
    state.settlementDetail = [],
    state.authorizations = []
  },
  
  [SET_CLAIMS]: (state, payload) => {
    state.createSettlement.includedClaims = payload
  },

  [SET_EXCLUDED_CLAIMS]: (state, payload) => {
    state.createSettlement.excludedClaims = payload
  },

  [CLEAR_CLAIMS]: (state) => {
    state.createSettlement.includedClaims = []
  },

  [CLEAR_EXCLUDED_CLAIMS]: (state) => {
    state.createSettlement.excludedClaims = []
  },

  [COMPLETE_ADD_AUTHORIZATIONS_STEP]: (state, payload) => {
    state.createSettlement.addAuthorizationsComplete = payload
  },
  
  [SET_SETTLEMENT_CREATION_RESULT]: (state, payload) => {
    state.createSettlement.createSettlementResult = payload
  },

  [RESET_SETTLEMENT_CREATION_STATE]: (state) => {
    state.createSettlement = {
      sponsorSelectionComplete: false,
      addAuthorizationsComplete: false,
      createSettlementResult: "",
      settlementId: {},
      sponsorSlug: {},
      dates: {
        from: "",
        to: ""
      },
      includedClaims: [],
      excludedClaims: [],
      actualStep: 1,
      errorMessage: '',
      coverages: []
    }
  },

  [SET_UPLOAD_SETTLEMENT_FILES_STATUS]: (state, payload) => {
    state.createSettlement.uploadedFiles = payload
  },

  [SET_SETTLEMENT_SUMMARY]: (state, payload) => {
    state.settlementSummary = payload
  },

  [SETTLEMENT_CREATION_SET_COVERAGES]: (state, payload) => {
    state.createSettlement.coverages = payload
  },

  [SETTLEMENT_DOCUMENTS]: (state, payload) => {
    state.settlementDocuments = payload
  },
  [MANUAL_AUTHORIZATION_TOGGLE]: (state, payload) => {
    state.manualAuthorizations.requireManualAuthorizations = payload
  },
  [MANUAL_AUTHORIZATION_SET_QUANTITY]: (state, payload) => {
    state.manualAuthorizations.quantity = payload
  },
  [MANUAL_AUTHORIZATION_SET_AMOUNT]: (state, payload) => {
    state.manualAuthorizations.amount = payload
  },
}